import React, { FunctionComponent, useContext } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';

import { URLStateContext } from '../URLState/URLState';
import BuildPerformanceOverview from './BuildPerformanceOverview/BuildPerformanceOverview';
import BuildWorkflowPerformance from './BuildWorkflowPerformance/BuildWorkflowPerformance';

const PerformanceIndex: FunctionComponent = () => {
  const { appId } = useParams<{ appId: string }>();
  const { to } = useContext(URLStateContext);

  return (
    <Switch>
      <Route
        component={BuildWorkflowPerformance}
        path="/:appId/buildPerformance/workflows/:workflowId"
      />
      <Route component={BuildPerformanceOverview} path="/:appId/buildPerformance" />
      <Redirect to={to(`/${appId}/buildPerformance`)} />
    </Switch>
  );
};

export default PerformanceIndex;
